import script from "./AppUpdateBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUpdateBanner.vue?vue&type=script&setup=true&lang=js"

import "./AppUpdateBanner.vue?vue&type=style&index=0&id=250473e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250473e7"]])

export default __exports__